<button class="lang-switcher" [matMenuTriggerFor]="langMenu">
  <mat-icon class="globe-icon">language</mat-icon>
  <span class="lang-code">{{ chipCodeKey | translate }}</span>
  <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
</button>
<mat-menu #langMenu="matMenu" class="lang-menu">
  <ng-container *ngIf="isIndiaMarket; else fullPicker">
    <!-- India: exactly one neutral English option (resolves to en-IN.json). -->
    <button mat-menu-item (click)="changeLanguage('en')" [class.active]="true">
      <span class="lang-option">{{ 'miscUi.langEnglishOnly' | translate }}</span>
    </button>
  </ng-container>
  <ng-template #fullPicker>
    <button mat-menu-item (click)="changeLanguage('en')" [class.active]="currentLanguage === 'en'">
      <span class="lang-option">{{ 'miscUi.langEnglish' | translate }}</span>
    </button>
    <button mat-menu-item (click)="changeLanguage('en-GB')" [class.active]="currentLanguage === 'en-GB'">
      <span class="lang-option">{{ 'miscUi.langEnglishUk' | translate }}</span>
    </button>
    <button mat-menu-item (click)="changeLanguage('he')" [class.active]="currentLanguage === 'he'">
      <span class="lang-option">{{ 'miscUi.langHebrew' | translate }}</span>
    </button>
  </ng-template>
</mat-menu>
